import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postProduct } from "../api";

export const useCreateProduct = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postProduct,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["PRODUCT"] });
      queryClient.refetchQueries({ queryKey: ["PRODUCT-ALL"] });
      router("/product");
      toast.success("Success Create Product");
    },
  });

  return { create: mutate, isPending };
};
